import { Caption, useStyles, useTheme } from '@archipro-design/aria';
import { isUserLoggedIn, useUser } from '~/modules/user';
import * as S from './SpecialtyPricingBanner.styles';
import React from 'react';
import LoginSignUpModal from '@modules/user/component/login-signup-modal/LoginSignUpModal';
import { useBoolean } from 'ahooks';
import { useVariantSelectionState } from '@modules/product/context/VariantSelectionContext';
import type Product from '@modules/product/type/product';
import type { VariantPriceType } from '@modules/product/util/get-variant-price';

const getSpecialtyPriceText = (
    product: Product,
    priceType?: VariantPriceType
): string | null => {
    switch (priceType) {
        case 'TradeProduct':
            return 'Trade discount applied';
        case 'SpecialtyPricedTradeProduct':
            return product.SpecialtyTradePriceText ?? null;
        case 'CustomerProduct':
            return product.SpecialtyCustomerPriceText ?? null;
    }
    return null;
};

const SpecialtyPricingBanner = ({ product }: { product: Product }) => {
    const { css } = useStyles();
    const theme = useTheme();
    const user = useUser();

    const { selectedVariant } = useVariantSelectionState();

    const [showSignIn, setShowSignIn] = useBoolean();

    const loggedIn = isUserLoggedIn(user);

    const bannerText = loggedIn
        ? getSpecialtyPriceText(product, selectedVariant?.SpecialtyPriceType)
        : product.SpecialtyBannerText;

    if (!bannerText) {
        return null;
    }

    return (
        <div className={css(S.BannerContainer)}>
            <Caption
                variant="02"
                variables={{
                    captionColor: theme.siteVariables.colors.primitive.black,
                }}
            >
                {loggedIn ? null : (
                    <button
                        onClick={() => {
                            setShowSignIn.setTrue();
                        }}
                        className={css(S.SignInButton)}
                    >
                        Sign in or create an account
                    </button>
                )}
                {bannerText}
            </Caption>
            <LoginSignUpModal
                login={{
                    open: showSignIn,
                    onCancel: setShowSignIn.setFalse,
                    onConfirm: setShowSignIn.setFalse,
                    onAuthSuccess: setShowSignIn.setFalse,
                    flow: null,
                    authSource: 'specialtyPricingBanner',
                }}
                forgotPassword={{
                    open: showSignIn,
                    onCancel: setShowSignIn.setFalse,
                }}
            />
        </div>
    );
};
export default SpecialtyPricingBanner;
